import { IdeaCardType } from './types'

export function isUploadVisible(
  type: IdeaCardType,
  isOwner: boolean,
  isHackathonStarted: boolean | undefined,
  searchParams: string
): boolean {
  if (type === IdeaCardType.Admin) return true
  if (!isOwner) return false
  const params = new URLSearchParams(searchParams)
  const uploadEnabled = params.get('upload') === 'true'
  return !!isHackathonStarted || uploadEnabled
}
